import { transformOperatorForRequest } from 'components/filter/filters-next/util';
import {
    DonorSearchRating,
    FilterRequestValue,
    FilterValue,
    ServerKey,
    UpstreamPreprocessTransform,
} from 'components/filter/types';

interface DonorsearchValue {
    key: ServerKey;
    value: string | DonorSearchRating[];
}

const preprocessTransformUpstream: UpstreamPreprocessTransform<
    DonorsearchValue['value'],
    DonorsearchValue
> = filter => ({
    ...filter,
    value: {
        key: filter.serverKey,
        value: filter.value,
    },
    serverKey: 'donorsearch' as ServerKey,
});

const transformUpstream = (
    filter: FilterValue<DonorsearchValue>,
): FilterRequestValue<DonorsearchValue['value']> & { key: ServerKey } => {
    return {
        key: filter.value.key,
        type: 'and',
        operator: filter.filterOperator
            ? transformOperatorForRequest(filter.filterOperator)
            : undefined,
        value: filter.value.value,
    };
};

function isDonorSearchFilterValue(value: FilterValue<any>): value is FilterValue<DonorsearchValue> {
    return value.value.key;
}

const isDonorSearchByServerKey = (key: ServerKey) => {
    switch (key) {
        case 'DS_Rating':
        case 'MajorGiftLikelihood':
        case 'AnnualFundLikelihood':
        case 'LikelyMatchesTotal':
        case 'LargestGiftLow':
            return true;
        default:
            return false;
    }
};

export {
    isDonorSearchByServerKey,
    isDonorSearchFilterValue,
    transformUpstream,
    preprocessTransformUpstream,
};
export type { DonorsearchValue };
